var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.diagnosed.length > 0)?_c('WorkCardDiagnostic',{attrs:{"data":_vm.diagnosed,"is-diagnosed":true}}):_c('h4',{staticClass:"mensaje"},[_vm._v("No tienes trabajos diagnosticados por ahora.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }